import { render, staticRenderFns } from "./MessagePanel.vue?vue&type=template&id=3672a0a1&scoped=true"
import script from "./MessagePanel.vue?vue&type=script&lang=js"
export * from "./MessagePanel.vue?vue&type=script&lang=js"
import style0 from "./MessagePanel.vue?vue&type=style&index=0&id=3672a0a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3672a0a1",
  null
  
)

export default component.exports